// extracted by mini-css-extract-plugin
export default {"input":"Input__input___vausB"};